 <!--客户案>新增>收款账户  -->
 <template>
  <div id="refund">
    <div class="btns">
      <el-button class="btnItems" v-if="hasPermiss('admin:collecation_account:delCollecationAccount')" @click="delBtns()">删除</el-button>
      <el-button class="btnItems" v-if="hasPermiss('admin:collecation_account:udpateCollecationAccount')" @click="modify()">编辑</el-button>
      <el-button class="btnItems" v-if="hasPermiss('admin:collecation_account:addCollecationAccount')" @click="add()">添加</el-button>
    </div>
    <div class="tablebox">
      <div class="glo_Table">
        <el-table
          :height="tableHeight"
          header-align="center"
          ref="mytable"
          @row-click="rowclick"
          :data="tableData"
          border
          stripe
          :highlight-current-row="true"
          @selection-change="handleSelectionChange"
        >
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60" />

          <el-table-column fixed="left" align="center" type="selection" width="60" />

          <el-table-column v-for="(item, index) in tableHead" :key="index" :label="item.name" :prop="item.field" align="center" :show-overflow-tooltip="true" :min-width="item.width" />
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <div class="addForm">
        <el-form :model="formdata" ref="addForm" v-if="isShowDialog" :rules="rules" inline-message label-width="100px" class="dia_form">
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="领款人:" prop="accountName">
                <el-input v-model="formdata.accountName" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="回款方式:" prop="refundConfDictId">
                <el-select v-model="formdata.refundConfDictId" placeholder="请选择">
                  <el-option v-for="(item, index) in CollectionArr" :key="index" :label="item.val" :value="item.confDictId" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="联系电话:" prop="tel">
                <el-input v-model="formdata.tel" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="手机号码:" prop="phone">
                <el-input v-model="formdata.phone" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="账号名称:" prop="bankName">
                <el-input v-model="formdata.bankName" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="账号:" prop="bankAccount">
                <el-input v-model="formdata.bankAccount" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="开户行地址:" prop="bankAddress">
                <el-input v-model="formdata.bankAddress" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="证件名称:" prop="idcardName">
                <el-input v-model="formdata.idcardName" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="证件号码:" prop="idcardNumber">
                <el-input v-model="formdata.idcardNumber" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="备注:" prop="remarks">
                <el-input type="textarea" rows="2" v-model="formdata.remarks" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </my-dialog>
  </div>
</template>
  <script >
import myDialog from "@/components/Dialog.vue";
import paging from "@/components/pagings.vue"; //分页组件
export default {
  components: {
    myDialog,
    paging,
  },
  props: {
    common: {
      type: Object,
    },
  },
  data() {
    return {
      number: this.common.customerNumber,
      pageStart: 1,
      pageCount: 0,
      pageTotal: this.$COMMON.pageTotals,
      CollectionArr: [],
      tableHeight: "75vh", //  表格高度
      tableData: [],
      selectTableData: [],
      tableHead: [
        {
          name: "收款人",
          field: "accountName",
          width: "120",
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
        },
        {
          name: "手机号码",
          field: "phone",
          width: "120",
        },
        {
          name: "回款方式",
          field: "refundMethod",
          width: "120",
        },
        {
          name: "银行名称",
          field: "bankName",
          width: "120",
        },
        {
          name: "银行账号",
          field: "bankAccount",
          width: "120",
        },
        {
          name: "开户行地址",
          field: "bankAddress",
          width: "120",
        },
        {
          name: "证件名称",
          field: "idcardName",
          width: "120",
        },
        {
          name: "证件号码",
          field: "idcardNumber",
          width: "120",
        },
        {
          name: "备注",
          field: "remarks",
          width: "120",
        },
      ],
      diaWidth: "50%",
      dialogTitle: "编辑收款账户",
      isShowDialog: false,
      formdata: {
        accountName: "",
        refundConfDictId: "",
        tel: "",
        phone: "",
        bankName: "",
        bankAccount: "",
        bankAddress: "",
        idcardName: "",
        idcardNumber: "",
        remarks: "",
      },
      defaultFormData: {
        documentNumber: null,
        documentStatus: null,
        bankAccount: null,
        bankAddress: null,
        bankName: null,
        idcardName: null,
        idcardNumber: null,
        phone: null,
        refundConfDictId: null,
        remarks: null,
        tel: null,
      },
      rules: {
        accountName: [{ required: true, message: "请输入", trigger: "blur" }],
        tel: [{ required: true, message: "请输入", trigger: "blur" }],
        bankName: [{ required: true, message: "请输入", trigger: "blur" }],
        bankAccount: [{ required: true, message: "请输入", trigger: "blur" }],
        refundConfDictId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.GetData();
    this.GetConfDictValDownList("return_settlement_method");
  },
  watch: {
    $route(to, from) {
      let id = this.$route.query.customerId || "";
      if (to.path == "/Customers/CustomMOD/Edit" && id) {
        this.customerId = id
        this.GetData();
      }
    },
  },
  methods: {
    // 获取收款账号列表
    GetData() {
      let queryData = new Object();
      queryData.pageStart = this.pageStart;
      queryData.pageTotal = this.pageTotal;
      queryData.documentStatus = "customer_v3:document_status";
      queryData.documentNumber = this.number;
      this.$API.CollecationAccountList(queryData).then((res) => {
        if (res.data.status === "success") {
          this.tableData = res.data.result?.data || [];
          this.pageCount = res.data.result?.pageCount || 0;
        } else {
          this.$message.error(`${res.data.message}---收款账号列表`);
        }
      });
    },

    // 获取字典数据--支付方式
    GetConfDictValDownList(param) {
      this.$API.getConfDictValDownList({ dictType: param }).then((res) => {
        if (res.data.status === "success") {
          this.CollectionArr = res.data.result;
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },

    // 删除
    delBtns(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              accountIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.accountIds.push(val.accountId);
            });
            this.$API.delCollecationAccount(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.accountIds.length > 2) {
                    delReq.accountIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.accountId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.accountId == delReq.accountIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },

    // 修改
    modify(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.isShowDialog = true;
        this.formdata = this.selectTableData[0];
      }
    },

    // 新建
    add() {
      this.isShowDialog = true;
    },

    // 分页-调整页码条数
    handleSizeChange(val) {
      this.pageTotal = val;
      this.GetData();
    },

    // 分页-调整页码
    handleCurrentChange(val) {
      this.pageStart = val;
      this.GetData();
    },

    // 表格
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    handleSelectionChange(e) {
      this.selectTableData = e;
    },

    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交

          let param = {};
          let defaultFormdata = {
            accountName: null,
            bankAccount: null,
            bankName: null,
            refundConfDictId: null,
            tel: null,
            bankAddress: null,
            idcardName: null,
            idcardNumber: null,
            phone: null,
            remarks: null,
          };
          for (var key in defaultFormdata) {
            if (this.formdata[key]) {
              eval("param." + key + "='" + this.formdata[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          if (this.formdata.accountId)
            param.accountId = this.formdata.accountId;
          if (param.accountId) {
            // 修改接口
            this.$API.udpateCollecationAccount(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          } else {
            // 新增接口
            param.documentNumber = this.number;
            param.documentStatus = "customer_v3:document_status";
            this.$API.addCollecationAccount(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.formdata = {
        accountName: "",
        refundConfDictId: "",
        tel: "",
        phone: "",
        bankName: "",
        bankAccount: "",
        bankAddress: "",
        idcardName: "",
        idcardNumber: "",
        remarks: "",
      };
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
  },
};
</script>
  <style scoped lang="less">
#refund {
  margin: 40px 40px;
  .btns {
    flex: 1;
    .btnItems {
      border: 1px solid #606266;
      background-color: #fff;
      color: #333;
      padding: 5px 20px;
      margin-left: 10px;
      margin-bottom: 8px;
    }

    .el-button:hover {
      border: 1px solid #ef7c0a;
      color: #ef7c0a;
    }
  }
  .addForm {
    margin: 10px 40px;
  }
  .dia_form {
    .el-form-item {
      margin-bottom: 0px;
      min-width: 260px;
    }
  }
}
</style>
  